import React, { FC, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// Components
import { useToast } from 'containers/ToastManager'
import { Title, Subtitle } from 'components/IndexLayout'

// Styles
import {
  IndexLayout,
  Wrapper,
  Text,
  StyledLinkButton,
  DoThisLaterButton,
} from './CheckYourInbox.styles'

// Types
import { useResendVerificationEmailMutation } from 'gqlTypes'

// Utils
import useUserProfile from 'modules/user/useUserProfile'
import useSignOut from 'modules/user/useSignOut'

// Constants
import { routes } from 'constants/routes'
import { useFlag } from 'constants/flags'

const CheckYourInboxView: FC = () => {
  const history = useHistory()
  const { showToast } = useToast()
  // TODO: Remove usage of onboarding-licenses-signup when release to production
  // https://github.com/sketch-hq/Cloud/issues/10012
  const isOnboardingLicensesSignupEnabled = useFlag(
    'onboarding-licenses-signup'
  )

  const { data } = useUserProfile()

  // Redirect already verified users to the entry route
  useEffect(() => {
    if (!isOnboardingLicensesSignupEnabled || data?.me.isVerified)
      history.push(routes.ENTRY.create({}))
  }, [data, history, isOnboardingLicensesSignupEnabled])

  // Operations
  const [resendVerificationEmail] = useResendVerificationEmailMutation({
    redirectErrors: true,
    onCompleted: () => showToast(`An email has been sent to ${data?.me.email}`),
    onError: 'show-toast',
  })

  const signOut = useSignOut()

  return (
    <IndexLayout variant="green" maxContainerWidth="595px">
      <Wrapper>
        <Title>Check Your Inbox</Title>
        <Subtitle>
          We just sent you a verification mail. Open it and confirm your email
          address.
        </Subtitle>
        <Text>
          Didn’t get the email?&nbsp;
          <StyledLinkButton onClick={() => resendVerificationEmail()}>
            Resend it
          </StyledLinkButton>
        </Text>
        <Text>
          Think you mistyped your email?&nbsp;
          <StyledLinkButton variant="secondary" onClick={signOut}>
            Sign out and try again
          </StyledLinkButton>
        </Text>
        <DoThisLaterButton
          to={routes.ENTRY.create({})}
          variant="primary-untinted">
          Do This Later
        </DoThisLaterButton>
      </Wrapper>
    </IndexLayout>
  )
}

export default CheckYourInboxView
